/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["orders-anonymous-new-order .action-buttons button{margin-right:8px}orders-anonymous-new-order .fixed-bottom{position:fixed;bottom:0;left:0;min-height:70px;width:100%;background-color:#ff0;justify-content:center;display:flex;flex-flow:column;padding:0 15px;border:2px solid red;font-size:25px}orders-anonymous-new-order .header-price{font-weight:700;float:right}"];
export { styles as styles };
